// Inline the small award marks so the server-rendered URL is not dependent on
// the separate static-asset deployment.
import multiYearLogo from './product-review-multi-year.svg?inline'
import singleYearLogo from './product-review-single-year.svg?inline'
import { defineMessage, useIntl } from 'react-intl'

const productReviewAwardWinnerAlt = defineMessage({
  id: 'dBE4k_X4n-1bnGF6gpyM',
  defaultMessage: 'ProductReview.com.au award winner',
})

interface Props {
  variant?: 'multi-year' | 'single-year'
  width: string
}

export function ProductReviewLogo({ variant = 'multi-year', width }: Props) {
  const intl = useIntl()
  const src = variant === 'single-year' ? singleYearLogo : multiYearLogo

  return <img src={src} width={width} alt={intl.formatMessage(productReviewAwardWinnerAlt)} />
}
